export default "/images/vendor/flag-icons/flags/4x3/sc.svg?4691653cefd138906e7bca113ba4818b";